import React, { useState, useRef, useLayoutEffect } from 'react';
import { BoxV2 as Box, Tooltip } from 'portal-commons';

interface TruncatedTableCellProps {
  children: React.ReactNode;
  sx?: object;
  'data-testid'?: string;
  showTooltip?: boolean;
}

const TruncatedTableCell: React.FC<TruncatedTableCellProps> = ({
  children,
  sx,
  showTooltip = false,
  ...rest
}) => {
  const [isTruncated, setIsTruncated] = useState(false);
  const textRef = useRef<HTMLSpanElement>(null);

  useLayoutEffect(() => {
    const element = textRef.current;
    if (element) {
      const isContentTruncated = element.scrollWidth > element.clientWidth;
      if (isContentTruncated !== isTruncated) {
        setIsTruncated(isContentTruncated);
      }
    }
  }, [children, isTruncated]);

  const textSpan = (
    <span
      ref={textRef}
      style={{
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        display: 'block',
        color: 'inherit',
      }}
    >
      {children}
    </span>
  );

  const shouldShowTooltip = showTooltip && isTruncated;

  return (
    <Box as="td" sx={sx} {...rest}>
      {shouldShowTooltip ? (
        <Tooltip title={children as string} placement="top" arrow>
          {textSpan}
        </Tooltip>
      ) : (
        textSpan
      )}
    </Box>
  );
};

export default TruncatedTableCell;
